/**
 * A clock that re-renders on an interval, so "4 minutes ago" does not sit there
 * saying "4 minutes ago" for an hour.
 *
 * Returning the instant rather than reading `Date.now()` inside each row also
 * means every relative time on a page is measured from the same moment.
 */

import { useEffect, useState } from 'react';

export function useNow(intervalMs = 15_000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  return now;
}
